module.exports = __webpack_public_path__ + "static/media/settings_blue.f479e91f.svg";